<template >
  <div class="mapView" id="mapView"></div>
 
</template>

<script>
import { initMap } from "../scripts/map";
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text,
} from "ol/style";
import { Vector as VectorLayer } from "ol/layer";
import { Overlay, Feature } from "ol";
import olBasicUtils from "../scripts/olBasicUtils";
import { getDefectpGeojson } from "@/apis/gisleungV1";
import { GeoJSON } from "ol/format";
export default {
  name: "MapView",
  data() {
    return {
      layerIds: [], //定义图层组
      vectorSource: null,
      pointsLayer: undefined,
      defects:[],
      lawyerLoading: false,
    };
  },
  mounted() {
    initMap("mapView", this);
    this.$nextTick(() => {
      this.loadGeoJsonData();
    });
  },
  created() {
  
  },
  methods: {
    loadGeoJsonData() {
      this.removeLayers();
      this.loadHSRoad_Line();
      this.loadYODLRoad_Line();
      this.loadZBJJRoad_Line();
      this.loadZNBDRoad_Line();
      this.loadZYJJRoad_Line();
      this.loadZMERoad_Line();
      this.loadLSCityPoint();
    },

    
 
    async  refreshLayer () {
      var previousLayer = this.pointsLayer;
      this.pointsLayer = new WebGLPointsLayer({
        source: this.vectorSource,
        style:styleFunction ,
        disableHitDetection: true,
      });

      console.log(this.pointsLayer)
      olMap.addLayer(this.pointsLayer);
      if (previousLayer) {
        olMap.removeLayer(previousLayer);
        previousLayer.dispose();
      }
    
    },
   
    async  animate () {
      olMap.render();
      window.requestAnimationFrame(this.animate);
    },

    // 加载陆上丝绸之路城市节点
    async loadLSCityPoint() {
      const points = await import("@data/json/陆上丝绸节点城市.json");
      //节点城市标注样式设置
      var styleFunction = function (feature) {
        return new Style({
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({
              color: "rgba(155, 70, 73, 1)",
            }),
            stroke: new Stroke({ color: "yellow", width: 1.5 }),
          }),
          stroke: new Stroke({ color: "yellow", width: 1.5 }),
          text: new Text({
            textAlign: "center", //位置
            textBaseline: "middle",
            text: feature.get("ZNAME"),
            font: "14px bold serif",
            offsetX: "10", //水平文本偏移量（以像素为单位）,正数将向右移动文本
            offsetY: "15",
            fill: new Fill({
              color: "#000000",
            }),
            stroke: new Stroke({
              color: "#FFFFFF",
              width: 3,
            }),
          }),
        });
      };

      olBasicUtils.addGeojsonLayer(
        "LSCity-point",
        points.default,
        styleFunction
      );
      this.layerIds.push("LSCity-point");
    },
    // 加载海上上丝绸之路城市节点
    async loadHSCityPoint() {
      const points = await import("@data/json/海上丝绸节点城市.json");
      //节点城市标注样式设置
      var styleFunction = function (feature) {
        return new Style({
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({
              color: "rgba(155, 70, 73, 1)",
            }),
            stroke: new Stroke({ color: "yellow", width: 1.5 }),
          }),
          stroke: new Stroke({ color: "yellow", width: 1.5 }),
          text: new Text({
            textAlign: "center", //位置
            textBaseline: "middle",
            text: feature.get("ZNAME"),
            font: "14px bold serif",
            offsetX: "10", //水平文本偏移量（以像素为单位）,正数将向右移动文本
            offsetY: "15",
            fill: new Fill({
              color: "#000000",
            }),
            stroke: new Stroke({
              color: "#FFFFFF",
              width: 3,
            }),
          }),
        });
      };

      olBasicUtils.addGeojsonLayer(
        "HSCity-point",
        points.default,
        styleFunction
      );
      this.layerIds.push("HSCity-point");
    },
    // 加载海上丝绸之路
    async loadHSRoad_Line() {
      const lines = await import("@data/json/海上丝绸之路.json");

      const textFill = new Fill({
        color: "#FED700", //线文本颜色
      });
      //线段样式
      const borderStroke = new Stroke({
        color: "#20B1AA",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "海上丝绸之路",
          placement: "line",
          offsetY: 10,
          offsetX: 40,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("HSRoad-line", lines.default, style);
      this.layerIds.push("HSRoad-line");
    },

    // 加载新亚欧大陆桥
    async loadYODLRoad_Line() {
      const lines = await import("@data/json/新亚欧大陆桥.json");

      const textFill = new Fill({
        color: "#FED700", //线文本颜色
      });
      //线段样式
      const borderStroke = new Stroke({
        color: "#E3A18C",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "新亚欧大陆桥",
          placement: "line",
          offsetY: 10,
          offsetX: 40,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("YODLRoad-line", lines.default, style);
      this.layerIds.push("YODLRoad-line");
    },

    // 加载中巴经济走廊
    async loadZBJJRoad_Line() {
      const lines = await import("@data/json/中巴经济走廊.json");
      const textFill = new Fill({
        color: "#FED700", //线文本颜色
      });
      //线段样式
      const borderStroke = new Stroke({
        color: "#FF00FE",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "中巴经济走廊",
          placement: "line",
          offsetY: 10,
          offsetX: 40,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("ZBJJRoad-line", lines.default, style);
      this.layerIds.push("ZBJJRoad-line");
    },

    // // 加载新亚欧大陆桥
    // async loadYODLRoad_Line() {
    //   const lines = await import("@data/json/新亚欧大陆桥.json");
    //   const textFill = new Fill({
    //     color: "#FED700", //线文本颜色

    //   });
    //   //线段样式
    //   const borderStroke = new Stroke({
    //     color: "#EA967A",
    //     width: 2.5,
    //     lineJoin: "round",
    //   });

    //   const style = new Style({
    //     stroke: borderStroke,
    //     text: new Text({
    //       fill: textFill,
    //       text: "新亚欧大陆桥",
    //       placement: "line",
    //       offsetY: 10,
    //       offsetX: 40,
    //       scale: 1.2, //文本规模
    //       stroke: new Stroke({
    //         color: "#363636",
    //         width: 2,
    //       }),
    //     }),
    //     fill: new Fill({
    //       color: "#eee",
    //     }),
    //   });

    //   olBasicUtils.addGeojsonLayer("YODLRoad-line", lines.default, style);
    //   this.layerIds.push("YODLRoad-line");
    // },

    // 中国-中南半岛经济走廊
    async loadZNBDRoad_Line() {
      const lines = await import("@data/json/中国-中南半岛经济走廊.json");
      const textFill = new Fill({
        color: "#FED700", //线文本颜色
      });
      //线段样式
      const borderStroke = new Stroke({
        color: "#90EE90",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "中国-中南半岛经济走廊",
          placement: "line",
          offsetY: 10,
          offsetX: 40,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("ZNBDRoad-line", lines.default, style);
      this.layerIds.push("ZNBDRoad-line");
    },

    // 中国-中亚经济走廊
    async loadZYJJRoad_Line() {
      const lines = await import("@data/json/中国-中亚经济走廊.json");
      const textFill = new Fill({
        color: "#FED700", //线文本颜色
      });

      const borderStroke = new Stroke({
        color: "#A52B2A",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "中国-中亚经济走廊",
          placement: "line",
          offsetY: 10,
          offsetX: 40,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("ZYJJRoad-line", lines.default, style);
      this.layerIds.push("ZYJJRoad-line");
    },
    // 中蒙俄经济走廊
    //  async loadZMERoad_Line () {
    //   const lines = await import('@data/json/中蒙俄经济走廊.json')
    //   const style = new Style({
    //     stroke: new Stroke({
    //       color: '#FED700',
    //       width: 2.5
    //     }),
    //     fill: new Fill({
    //       color: '#eee'
    //     })
    //   })

    async loadZMERoad_Line() {
      const lines = await import("@data/json/中蒙俄经济走廊.json");

      const textFill = new Fill({
        color: "#FED700", //线文本颜色
        backgroundStroke: "#FFFF",
      });

      const borderStroke = new Stroke({
        color: "#FED700",
        width: 2.5,
        lineJoin: "round",
      });

      const style = new Style({
        stroke: borderStroke,
        text: new Text({
          fill: textFill,
          text: "中蒙俄经济走廊",
          placement: "line",
          offsetY: 10,
          offsetX: 10,
          scale: 1.2, //文本规模
          stroke: new Stroke({
            color: "#363636",
            width: 2,
          }),
        }),
        fill: new Fill({
          color: "#eee",
        }),
      });

      olBasicUtils.addGeojsonLayer("ZMERoad-line", lines.default, style);
      this.layerIds.push("ZMERoad-line");
    },

    removeLayers() {
      olBasicUtils.removeLayerByIds(this.layerIds);
      this.layerIds = [];
    },
  },
};
</script>

<style lang="less" scoped>
.mapView {
  width: 100%;
  height:100%;
  margin-left: 0px;
}

</style>
